const ItemGenerator = require('../../../game_items/ItemGenerator');
const Staff = require('../../../game_items/equipment/weapon/Staff');
const LightBoots = require('../../../game_items/equipment/boots/LightBoots.js');
const LightHelmet = require('../../../game_items/equipment/helmet/LightHelmet.js');
const LightTorsoe = require('../../../game_items/equipment/torsoe/LightTorsoe.js');
const getMobEquipmenAssignmentFromBags = require('../mobs/getMobEquipmenAssignmentFromBags');

const wraith = (level) => {
  const handle = 'wraith';
  const types = ['flying', 'magic', 'undead'];
  const bags = [
    {
      value: {
        items: [
          ItemGenerator.getCavernsMobItem(Staff, level),
          ItemGenerator.getCavernsMobItem(LightBoots, level),
          ItemGenerator.getCavernsMobItem(LightHelmet, level),
          ItemGenerator.getCavernsMobItem(LightTorsoe, level),
        ].map((item) => ({ value: item })),
      },
    },
  ];
  const AI_PRIORITIES = ['support', 'interference', 'dps_ranged', 'dps_close', 'tank'];
  const equipped_abilities = [
    { value: 'move' },
    { value: 'melee_attack' },
    { value: 'leap' },
    { value: 'ice_nine' },
    { value: 'void_spike' },
  ];

  return {
    handle,
    types,
    level,
    getAbilityTrees: ((bound_level) => [
      {
        handle: 'wraith_abilities',
        abilities: {
          move: { handle: 'move', level: 1 },
          melee_attack: { handle: 'melee_attack', level: 1 },
          blurred_form: {
            handle: 'blurred_form',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
            passive: true,
          },
          ice_nine: {
            handle: 'ice_nine',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
          leap: {
            handle: 'leap',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
          void_spike: {
            handle: 'void_spike',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
        },
      },
    ]).bind(null, level),
    getBaseAttributes: ((bound_level) => ({
      learning: Math.round(9 + bound_level * 1.1 + Math.random() * 3),
      perception: Math.round(6 + bound_level * 0.7 + Math.random() * 3),
      mana: Math.round(10 + bound_level * 1.2 + Math.random() * 3),
      toughness: Math.round(4 + bound_level * 0.5 + Math.random() * 3),
      strength: Math.round(4 + bound_level * 0.35 + Math.random() * 3),
      willpower: Math.round(7 + bound_level * 0.9 + Math.random() * 3),
      dexterity: Math.round(5 + bound_level * 0.6 + Math.random() * 3),
    })).bind(null, level),
    getDefaultAIConfig: () => AI_PRIORITIES,
    xpValue: level * 1200,
    drops_gold: true,
    drops_equipment: true,
    bags,
    build: {
      ai: {
        priorities: AI_PRIORITIES,
        settings: {
          chanceToSkipRoles: true,
          autoMove: true,
          waitForAPMP: false,
        },
      },
      ai_unit: true,
      equipment_assignment: getMobEquipmenAssignmentFromBags(bags),
      equipped_abilities,
      handle,
      level,
      team: 'black',
      types,
      unit: true,
    },
  };
};
module.exports = wraith;
